<template>
  <v-dialog v-model="dialog" max-width="350">
    <div class="scartati">
      <v-card>
        <v-card-title class="cyan headline">
          <span class="white--text">Scarta calciatori</span>
          <v-spacer></v-spacer>
          <v-btn depressed class="white--text" light icon @click="dismiss">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <!-- body -->
        <asta-svincolati
          :maxQuotazione="999999999999"
          :dialogParent="dialog"
          showButtonsScartaRiabilita
          :showStats="false"
          :showMainStatus="false"
          :showButtonScartati="false"
          showQuotazioni
          textScuro
          ripple
        ></asta-svincolati>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import db from "../../js/db";
import Constants from "../../js/constants";
import * as Helpers from "../../js/helpers";
import mixins from "../../js/mixins";
import Vuex from "vuex";
import AstaSvincolati from "@/components/AstaSvincolati";

export default {
  name: "dialog-scarta-calciatori",
  mixins: [mixins],
  components: { AstaSvincolati },
  data() {
    return {
      dialog: false,
    };
  },
  mounted() {
    console.log("--> AstaScartatiAggiungi ready.");
    db.on("manageAggiungiScartati", this.show);
  },
  destroyed() {
    console.log("<-- AstaScartatiAggiungi destroyed.");
    db.off("manageAggiungiScartati", this.show);
  },
  methods: {
    show() {
      this.dialog = true;
    },
    dismiss() {
      this.dialog = false;
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped></style>
